// extracted by mini-css-extract-plugin
export default {"title":"CardTitle_title__FEe3p","title-input":"CardTitle_title-input__tKEDW"};